import React, { useState } from 'react';
import { queryFamilyForDonation } from "../../service/DonationApi";
import { useCheckAccess, } from "../../utils/Utilities";
import { Loading, Breadcrumbs } from "../../components/shared";
import { Link, useNavigate } from 'react-router-dom';



// Main component for donation creation
const FamilySearch = () => {
  useCheckAccess('FamilyRO');

  const [familyId, setFamilyId] = useState('');
  const [mobile, setMobile] = useState('');
  const [aadhar, setAadhar] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [selectedMemberId, setSelectedMemberId] = useState('');
  const [searchError, setSearchError] = useState('');
  const [validationError, setValidationError] = useState('');
  const [searching, setSearching] = useState(false);
  const navigate = useNavigate();


  const isValidSearchInput = () => {
    if (!familyId && !mobile && !aadhar) {
      setValidationError("தயவுசெய்து குடும்ப எண், Mobile அல்லது Aadhaar ஒன்றை உள்ளிடவும்.");
      return false;
    }

    if (familyId && !/^\d{1,4}$/.test(familyId)) {
      setValidationError("குடும்ப எண் 1 முதல் 4 இலக்க எண் இருக்க வேண்டும்.");
      return false;
    }

    if (mobile && !/^\d{10}$/.test(mobile)) {
      setValidationError("மொபைல் எண் 10 இலக்க எண் இருக்க வேண்டும்.");
      return false;
    }

    if (aadhar && !/^\d{12}$/.test(aadhar)) {
      setValidationError("ஆதார் எண் 12 இலக்க எண் இருக்க வேண்டும்.");
      return false;
    }

    setValidationError('');
    return true;
  };

  const handleSearchFamily = async () => {
    setSearchResult(null);
    setSearchError('');
    setSelectedMemberId('');
    setSearching(true);
    if (!isValidSearchInput()) {
      setSearching(false);
      return;
    }

    try {
      const response = await queryFamilyForDonation({ familyId, mobile, aadhar });

      if (response?.family || response?.members?.length > 0) {
        setSearchResult(response);
        if (response.family?.id) {
          setFamilyId(response.family.id);
        }
      } else {
        setSearchError("No matching family found.");
      }
    } catch (err) {
      setSearchError("Error fetching family data.");
      console.error(err);
    } finally {
      setSearching(false);
    }
  };


  return (
    <>
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h2>குடும்பத்தைத் தேடு</h2>

            <div className="auth_element">
              <label className="auth_label">குடும்ப எண்:</label>
              <input value={familyId} onChange={e => setFamilyId(e.target.value)}
                className="auth_input"
                inputMode="numeric"
                maxLength="4"
              />

              <label className="auth_label">மொபைல்:</label>
              <input value={mobile} onChange={e => setMobile(e.target.value)}
                className="auth_input"
                inputMode="numeric"
                maxLength="10" />

              <label className="auth_label">ஆதார்:</label>
              <input value={aadhar} onChange={e => setAadhar(e.target.value)}
                className="auth_input"
                inputMode="numeric"
                maxLength="14"
              />

              {searching ? (
                <Loading />
              ) : (
                <button onClick={handleSearchFamily}>குடும்பத்தைத் தேடு</button>
              )}

              {validationError && <p style={{ color: 'red' }}>{validationError}</p>}
            </div>

            {searchError && <p style={{ color: 'red' }}>{searchError}</p>}

            {searchResult?.family && (
              <>

                <div className="detail-item" style={{
                  border: "1px solid var(--highlight-shadow-color)",
                  padding: "1rem",
                  marginTop: "1rem",

                }}>

                  <span className="detail-label"><strong>குடும்ப எண்:</strong></span> <span className="detail-value">

                    {searchResult.family.id}

                  </span>
                  <span className="detail-label"><strong>கூட்டம்:</strong></span><span className="detail-value"> {searchResult.family.kootamName}
                  </span>
                  <span className="detail-label"><strong>தலைமை பெயர்:</strong> </span><span className="detail-value">{searchResult.family.familyHeadFirstName} {searchResult.family.familyHeadLastName}
                  </span>
                  {searchResult.family.tempAddressName_tamil && (
                    <>
                      <br />
                      <span className="detail-label"><strong>தற்காலிக முகவரி:</strong> </span>
                      <span className="detail-value">{searchResult.family.tempAddressName_tamil}, {searchResult.family.tempAddressBlock_tamil}, {searchResult.family.tempAddressDistrict_tamil}
                      </span>
                    </>
                  )}
                  <br />
                  <span className="detail-label"><strong>நிரந்தர முகவரி:</strong> </span>
                  <span className="detail-value">{searchResult.family.permanentAddressName_tamil}, {searchResult.family.permanentAddressBlock_tamil}, {searchResult.family.permanentAddressDistrict_tamil}
                  </span>
                  <br />
                  <div>
                    <button
                      type="button"
                      style={{ display: 'inline', marginRight: '4px', marginLeft: '4px' }}  // Adds margin-right between buttons
                      onClick={() => navigate(`/family/view/${searchResult.family.id}`)}
                    >
                      👁️
                    </button>
                    <button
                      type="button"
                      style={{ display: 'inline' }}
                      onClick={() => navigate(`/family/update/${searchResult.family.id}`)}
                    >
                      ✏️
                    </button></div>
                </div>
                {searchResult.family.status !== 'active' && (
                  <div style={{ marginTop: '1rem', color: 'red', fontWeight: 'bold' }}>
                    ⚠️ குடும்ப விவரங்கள் முலுமையாக இல்லை. தயவுசெய்து விண்ணப்பப் படிவத்தை பூர்த்தி செய்யவும்.
                    <br></br>
                  </div>

                )}

              </>
            )}


            {searchResult?.members?.length > 0 && (
              <div className="auth_element" style={{ marginTop: "1rem" }}>
                <h3>குடும்ப உறுப்பினர்கள்:</h3>
                <br />
                {searchResult.members.map((member, index) => (
                  <div
                    key={member.uid}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#e6f2ff",
                      padding: "0.75rem",
                      borderRadius: "6px",
                      marginBottom: "0.75rem"
                    }}
                  >
                    <label className='auth_radio' style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="radio"
                        name="selectedMember"
                        value={member.uid}
                        checked={selectedMemberId === member.uid}
                        onChange={() => setSelectedMemberId(member.uid)}
                        style={{ marginRight: '8px' }}
                      />

                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <strong>{member.firstName} {member.lastName}</strong>
                          <button
                            type="button"
                            style={{ marginLeft: '8px', marginRight: '4px' }}
                            onClick={() => navigate(`/family/member-view/${member.id}`)}
                          >
                            👁️
                          </button>
                          <button
                            type="button"
                            onClick={() => navigate(`/family/member-update/${member.id}`)}
                          >
                            ✏️
                          </button>
                        </div>

                        {(member.mobile || member.mobile2) && (
                          <div style={{ marginTop: '4px' }}>
                            📱 {member.mobile || ''}{member.mobile2 ? (member.mobile ? ' / ' : '') + member.mobile2 : ''}
                          </div>
                        )}
                      </div>
                    </label>

                    {member.status !== 'active' && (
                      <div style={{ color: 'red', marginLeft: '2rem', fontSize: '0.9rem' }}>
                        ⚠️ இந்த உறுப்பினர் ஆதார் விவரங்களை சமர்ப்பிக்கவும்.
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}



          </div>
        </div>
      </div>


    </>
  );
};

export default FamilySearch;
